// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"4c94121c","455":"11ecb7c5","977":"5fec62a4"}[chunkId] + ".chunk.js";
};